// Решения по конфликтам импорта: resolutions[key] = { skip?, filialId?, color?, name?, keep?, asNew? }
// (контракт ImportResolver на бэке). Здесь - чтение и проверка «решено ли».

export const CONFLICT_ORDER = ['no_filial', 'unknown_color', 'duplicate', 'name_taken', 'foreign_filial']

export const CONFLICT_TEXTS = {
  no_filial: {
    title: 'Филиал не определён',
    text: 'Укажите филиал или пропустите зоны. Решение по группе применяется ко всем её зонам.',
  },
  unknown_color: {
    title: 'Неизвестный цвет',
    text: 'Цвет заливки не похож ни на зелёный, ни на жёлтый, ни на красный. Выберите цвет зоны.',
  },
  duplicate: {
    title: 'Несколько полигонов на одну зону',
    text: 'Один полигон обновит зону, остальные можно добавить новыми зонами или пропустить.',
  },
  name_taken: {
    title: 'Имя занято',
    text: 'Имена зон в сети уникальны. Задайте другое имя или пропустите зону.',
  },
  foreign_filial: {
    title: 'Зона другого филиала',
    text: 'В файле у зоны указан другой филиал. Зона останется в своём филиале или будет пропущена.',
  },
}

// ключи строк, которых касается элемент конфликта
export function conflictKeys (item) {
  return item.keys || [item.key]
}

// режим полигона в группе дубля: update (нет флагов), asNew или skip
export function duplicateMode (res) {
  if (!res) return 'update'
  if (res.skip) return 'skip'
  if (res.asNew) return 'asNew'
  return 'update'
}

export function isDecided (type, item, resolutions) {
  const res = (key) => resolutions[key] || {}
  switch (type) {
    case 'no_filial':
      return conflictKeys(item).every((k) => res(k).skip || res(k).filialId)
    case 'unknown_color':
      return !!(res(item.key).skip || res(item.key).color)
    case 'duplicate':
      return item.keys.filter((k) => duplicateMode(resolutions[k]) === 'update').length <= 1
    case 'name_taken':
      return !!(res(item.key).skip || (res(item.key).name || '').trim())
    case 'foreign_filial':
      return !!(res(item.key).skip || res(item.key).keep)
    default:
      return true
  }
}
